import {styled} from "@mui/material/styles";
import {CreditCard} from "@mui/icons-material";
import {Box, Button, ButtonBase, Grid, Typography} from "@mui/material";

export const BookingPaymentButton = styled(Button)(() => ({
  fontFamily: 'Inter',
  fontSize: '0.9em',
  fontWeight: '500',
  lineHeight: '1.57em',
  letterSpaceing: '0.03em', // keeping for consistency
}));

export const BookingPaymentPayIcon = styled(CreditCard)(() => ({
  marginRight: '0.3em',
}));

export const BookingPaymentPaymentSaveInfoContainer = styled(Box)(({theme}) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '0.5em',
  marginTop: '1.5em',
  marginBottom: '1.5em',
}));

export const BookingPaymentNoPayment = styled(Typography)(() => ({
  fontWeight: '500',
  lineHeight: '1.71em',
  fontFamily: 'Inter',
  color: 'rgba(0, 0, 0, 0.87)',
  marginBottom: '2em',
  marginTop: '2em',
  fontSize: '1.71em',
  textAlign: 'center'
}));

export const BookingCardBookCardContainer = styled(ButtonBase)(({theme}) => ({
  padding: '1.43em',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  width: '100%',
}));

export const BookingCardGap = styled(Grid)(() => ({
  gap: '0.5em'
}));

export const BookingCardCardImg = styled('img')(() => ({
  width: '3.42em',
  height: '2.28em',
  objectfit: 'cover'
}));

export const BookingCardCardTitle = styled(Typography)(() => ({
  fontSize: '1.14em',
  lineHeight: '1.71em',
  fontWeight: '500',
  fontFamily: 'Inter'
}));

export const BookingCardCircle = styled(Box)(({theme}) => ({
  width: '1.14em',
  height: '1.14em',
  borderRadius: '50%',
  border: `2px solid ${theme.palette.primary.main}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer'
}));

export const BookingCardCircleInner = styled(Box)(({theme}) => ({
  width: '0.57em',
  height: '0.57em',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
}));
